import { render, staticRenderFns } from "./AppointmentRoomAvailability.vue?vue&type=template&id=004d8815&"
import script from "./AppointmentRoomAvailability.vue?vue&type=script&lang=js&"
export * from "./AppointmentRoomAvailability.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentRoomAvailability.vue?vue&type=style&index=0&id=004d8815&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports